import React, { useState } from "react";
import {
  Card,
  Table,
  Row,
  Col,
  Form,
  Button,
  Container,
  Alert,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { addDays, getDay, getDate } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

import { Redirect } from "react-router-dom";
import _ from 'lodash';
import "bootstrap/dist/css/bootstrap.min.css";
import "./PanelResponse.css";
import api from "./api-endpoints.json";
import { format } from 'date-fns';
import { TimePicker } from 'antd';
import moment from "moment";
import 'antd/dist/antd.css';
import './index.css';
import Multiselect from 'multiselect-react-dropdown';


const PanelResponse = (props) => {
  var options = new Array({ name: 'Monday', id: 1 }, { name: 'Tuesday', id: 2 }, { name: 'Wednesday', id: 3 }, { name: 'Thursday', id: 4 }, { name: 'Friday', id: 5 }, { name: 'Saturday', id: 6 }, { name: 'Sunday', id: 7 });
  const [checkboxState, setCheckboxState] = useState(false);
  const [showReview, setShowReview] = useState(false);
  const [slotDt, setSlotDt] = useState(undefined);
  const [recSlotDt, setRecSlotDt] = useState([]);
  const [slotStartTime, setSlotStartTime] = useState('09:00');
  const [slotEndTime, setSlotEndTime] = useState('10:00');
  //const [currentSlot, setCurrentSlot] = useState([]);
  const [data, setData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [validatedForm, setValidatedForm] = useState(false);
  const [alertMessageContent, setAlertMessageContent] = useState("");
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const [alertMessageContent2, setAlertMessageContent2] = useState("");
  const [showAlertMessage2, setShowAlertMessage2] = useState(false);
  const [recDay, setRecDay] = useState(1);
  const [recDays, setRecDays] = useState([]);
  const [recStartDate, setRecStartDate] = useState(undefined);
  const [recEndDate, setRecEndDate] = useState(undefined);
  const customDateFormat = 'dd/MM/yyyy';
  const customDateAndTimeFormat = 'dd/MM/yyyy kk:mm';
  const Format = 'HH:mm';
  const { RangePicker } = TimePicker;
  const deleteAllTimeSlot = (e) => {
    data.map((entry, key) => {
      if (entry.isSlected) {
        data.splice(key, 1);

        finalData.map((val, index) => {
          if (val.SlotDate == entry.slotDate) {
            if (val.SlotInformation.length == 1) {
              finalData.splice(index, 1);
            } else {
              val.SlotInformation.map((slotVal, slotIndex) => {
                if (slotVal.slotStart == entry.slotStart && slotVal.slotEnd == entry.slotEnd) {
                  val.SlotInformation.splice(slotIndex, 1);
                }
              })
            }
          }
        })
      }
    });

    setData([].concat(data));
    setFinalData([].concat(finalData));
  };
  const slotInRange = (time) => {
    console.log("inside slotInRange");
    console.log("slot start time..",slotStartTime,"db slot start time..",time.slotStart);
    console.log("slot start time..",slotEndTime,"db slot start time..",time.slotEnd);
    return !(
      (slotStartTime.replace(/:/g, "") <= time.slotStart.replace(/:/g, "") && slotEndTime.replace(/:/g, "") <= time.slotStart.replace(/:/g, ""))
      ||
      (slotStartTime.replace(/:/g, "") >= time.slotEnd.replace(/:/g, "") && slotEndTime.replace(/:/g, "") >= time.slotEnd.replace(/:/g, ""))

    );
  }
  const checkDbSlotDate = (currentSlot, slotDate) => {
    console.log("inside checkDbSlotDate");
    if (currentSlot.length != 0)
    {
      for (var i = 0; i < currentSlot.length; i++) {
      if (currentSlot[i].Item.SlotDate === moment(slotDate).format("DD/MM/YYYY")) {
        return true;
      }
    }
    console.log("inside checkDbSlotDate....returning false");
      return false;
 }
}
  const checkDbSlotTime = (currentSlot) => {
    console.log("inside checkDbSlotTime");
    if (currentSlot.length != 0) {
      for (var i = 0; i < currentSlot.length; i++) {
        if (currentSlot[i].Item.SlotInformation.filter(slotInRange).length > 0) {
          console.log("inside checkDbSlotTime...returning true");
          return true;
        }
      }
    }
    console.log("inside checkDbSlotTime...returning false");
    return false;
   }
  const checkRecordAlreadyExists = (slotDate,currentSlot) => {
    console.log("inside check record already");
    var flagSlotExists = false, flagDateExists = false;
    if(checkDbSlotDate(currentSlot,slotDate)){
      flagDateExists = true;
    }
    if(checkDbSlotTime(currentSlot)){
      flagSlotExists = true;
    }

    finalData.map((val, index) => {
      if (val.SlotDate == moment(slotDate).format("DD/MM/YYYY")) {

        flagDateExists = true;

        if (val.SlotInformation.filter(slotInRange).length > 0){
          flagSlotExists = true;
        } else {
          var slotsJson = {};
          slotsJson["slotStart"] = slotStartTime;
          slotsJson["slotEnd"] = slotEndTime;
          slotsJson["submittedTime"] = format(new Date(), customDateAndTimeFormat);
          val["SlotInformation"] = val["SlotInformation"].concat(slotsJson);

          var jsonData = {};
          jsonData["isSlected"] = false;
          jsonData["slotDate"] = moment(slotDate).format("DD/MM/YYYY");
          jsonData["slotStart"] = slotStartTime;
          jsonData["slotEnd"] = slotEndTime;
          setData(data.concat(jsonData));
        }
      }
    })
    console.log("flagDateExists=",flagDateExists,"flagSlotExists=",flagSlotExists);
    return { flagDateExists, flagSlotExists };
  }

  const handleChangeDebut = (range) => {
    const valueOfInput1 = range[0].format();
    const valueOfInput2 = range[1].format();
  }
  const addSlot = (slotDate,currentSlot) => {
    let isValid = false, ifRecordAlreadyExists = false;
    setShowAlertMessage(false);
    setAlertMessageContent(
      "One or more errors detected while submitting. Please review and ensure all the details are filled correctly"
    );
    if (slotDate && slotStartTime && slotEndTime) {
      if (slotStartTime.replace(/:/g, "") < 900 || slotStartTime.replace(/:/g, "") > 1900) {
        setAlertMessageContent("Slot start time should be in between 9am to 7pm only");
      } else if (slotEndTime.replace(/:/g, "") < 900 || slotEndTime.replace(/:/g, "") > 2100) {
        setAlertMessageContent("Slot end time should be in between 9am to 9pm only");
      } else if (slotStartTime.replace(/:/g, "") >= slotEndTime.replace(/:/g, "")) {
        setAlertMessageContent("Slot start time should always be less than slot end time");
      } else {
        ifRecordAlreadyExists = checkRecordAlreadyExists(slotDate,currentSlot);
        if (ifRecordAlreadyExists.flagDateExists&&ifRecordAlreadyExists.flagSlotExists) {
            setAlertMessageContent("Record already exists for date",moment(slotDate).format("DD/MM/YYYY"));
          } else {
          isValid = true;
        }
      }
    }

    if (isValid) {
      console.log("inside isValid method");
      var jsonData = {};

      jsonData["isSlected"] = false;
      jsonData["slotDate"] = moment(slotDate).format("DD/MM/YYYY");
      jsonData["slotStart"] = slotStartTime;
      jsonData["slotEnd"] = slotEndTime;
      setData(prevData => prevData.concat(jsonData));

      var finalJsonData = {};

      finalJsonData["SlotDate"] = moment(slotDate).format("DD/MM/YYYY");
      finalJsonData["SlotInformation"] = [];
      var slotsJson = {};
      slotsJson["slotStart"] = slotStartTime;
      slotsJson["slotEnd"] = slotEndTime;
      slotsJson["submittedTime"] = format(new Date(), customDateAndTimeFormat);

      finalJsonData["SlotInformation"] = finalJsonData["SlotInformation"].concat(slotsJson);
      setFinalData(prevFinalData => prevFinalData.concat(finalJsonData));
      setShowAlertMessage(false);
    } else {
      setShowAlertMessage(true);
    }

  }       

    const addTimeSlot = (e) => {
      var curentSlot=[];
      if (!e) {
        var slotDates=[slotDt];
        getCurrentSlot(slotDates).then((res)=>{
          console.log("before setting currentSLot res is",res);
          if(res.data.body.length!=0)
          {
            curentSlot=res.data.body;
            console.log("currentSLot set is",curentSlot);
          }
          addSlot(slotDates[0],curentSlot);
      }).catch((err) => {
          console.log('err while fetching current slot for this user', err);
          setAlertMessageContent("Network err. Pls try later");
          setShowAlertMessage(true);
  
        });
      } else {

        var slotDates = [];
        let currentDate = new Date(recStartDate);
        while (currentDate <= recEndDate) {
          for (var i = 0; i < recDays.length; i++) {
            if (currentDate.getDay() == recDays[i].id) {
              slotDates.push(new Date(currentDate));
            }
            //Do something
          }
          let newDate = currentDate.setDate(currentDate.getDate() + 1);
          currentDate = new Date(newDate);
        }
      getCurrentSlot(slotDates).then((res)=>{
        console.log("before setting currentSLot res is",res);
        if(res.data.body.length!=0)
        {
          curentSlot=res.data.body;
          console.log("currentSLot set is",curentSlot);
        }
        for(var i=0;i< slotDates.length;i++){
          console.log("processing started fo date",slotDates[i])
        addSlot(slotDates[i],curentSlot);
      }
    }).catch((err) => {
        console.log('err while fetching current slot for this user', err);
        setAlertMessageContent("Network err. Pls try later");
        setShowAlertMessage(true);

      });
    }
    }
    const isValidDate = (date) => {
      const day = getDay(date);

      if (
        getDate(date) === getDate(moment(new Date()).toDate()) + 1 ||
        getDate(date) === getDate(moment(new Date()).toDate())
      ) {
        return false;
      }
      //return day !== 0;
      return true;
    };
    const getCurrentSlot = async (slotDates) => {
      slotDates=slotDates.map((date)=>moment(date).format("DD/MM/YYYY"));
      console.log("inside getcurrentSlot method with slotdates",slotDates);
      let currentSlot = await axios({
        method: "post",
        url: api.GetCurrentSlot,
        data: {
          PhoneNumber: props.phoneNumber,
          data: slotDates,
        },
        config: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
        },
      });
      console.log("result returned form get currentslot",currentSlot);
      return currentSlot;
      
      //.then((res) => {
      //   console.log("result returned from getcurrentslot:", res);
      //   if (res.status === 200) {
      //     if (Object.keys(res.data.body).length!=0) {
      //       console.log("res.data.body is not null");
      //       return res.data.body;
      //       //setCurrentSlot(res.data.body.Item);
      //     } else{ 
      //       console.log("res.data.body is  null");
      //     }
      //   }
      // }).catch((err) => {
      //   console.log('err while fetching current slot for this user', err);
      //   setAlertMessageContent("Network err. Pls try later");
      //   setShowAlertMessage(true);

      // });
    }
    const handleSubmit = async (event) => {
      event.preventDefault();
      console.log("submitted follwing recirds:",JSON.stringify(finalData));
      if (finalData.length == 0) {
        setAlertMessageContent("Please add some records");
        setShowAlertMessage(true);
      } else {
        setAlertMessageContent("Please Wait, submitting");
        setShowAlertMessage(true);
        await axios({
          method: "post",
          url: api.ReceiveResponse,
          data: {
            PhoneNumber: props.phoneNumber,
            data: finalData,
          },
          config: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": true,
          },
        }).then((res) => {
          if (res.data === "Data Received") {
            setValidatedForm(true);
          }
        }).catch((err) => {
          console.log('err while submitting', err);
          setAlertMessageContent("Network err. Pls try later");
          setShowAlertMessage(true);

        });
        setShowAlertMessage2(false);
      }
    };

    const headerText = props.header.split('\n').map((item, i) => <p style={{ fontSize: "18px" }} key={i}>{item}</p>);
    const footerText = props.footer.split('\n').map((item, i) => <p style={{ fontSize: "18px" }} key={i}>{item}</p>);


    return (
      <div className="panelresponse-page-content">

        <div className="panelresponse-page-head">
          <img src={require("./logo.png")} alt="logo" />
          <br />
          <h4 className="panelresponse-page-subheading">Panelist Time Scheduling</h4>
        </div>
        <div className="panelresponse-page-body">
          <Form className="form-card">


            <React.Fragment>
              <Card className="information-card" >
                <Card.Body className="card-body-header">
                  <Card.Text className="text-left">{headerText}</Card.Text>
                </Card.Body>
              </Card>
              <Card>
                <Card.Body>
                  <Card.Title>Time Slot Preference</Card.Title>

                  <Card>
                    <Card.Body>
                      <div className="preference-card-title">
                      </div>
                      <Form.Group as={Row} controlId="formDate1 required">
                        <Form.Label column sm={4}>
                          Date
                        </Form.Label>
                        <Col sm={8}>
                          <DatePicker
                            className="date-pick"
                            selected={slotDt}
                            dateFormat="dd/MM/yyyy"
                            onChange={(date) => { setSlotDt(date); setShowAlertMessage(false); }}
                            maxDate={addDays(
                              moment(new Date()).toDate(),
                              22
                            )}
                            minDate={new Date()}
                            filterDate={isValidDate}
                            placeholderText="Select a date"
                            required={true}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formTime1">
                        <Form.Label column sm={4}>
                          Start Time Slot
                        </Form.Label>
                        <Col sm={8}>
                          <TimePicker

                            minuteStep={15}
                            disabledHours={() => [0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23, 24]}
                            hideDisabledOptions={true}
                            format="HH:mm"
                            onSelect={(time) => {
                              setSlotStartTime(moment(time).format('HH:mm'));
                              setShowAlertMessage(false);
                            }}
                            autoFocus={true}
                            value={moment(slotStartTime, 'HH:mm')}
                          />

                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formTime1">
                        <Form.Label column sm={4}>
                          End Time Slot
                        </Form.Label>
                        <Col sm={8}>
                          <TimePicker

                            minuteStep={15}
                            disabledHours={() => [0, 1, 2, 3, 4, 5, 6, 7, 8, 22, 23, 24]}
                            hideDisabledOptions={true}
                            format="HH:mm"
                            onSelect={(time) => {
                              setSlotEndTime(moment(time).format('HH:mm'));
                              setShowAlertMessage(false);
                            }}
                            autoFocus={true}
                            value={moment(slotEndTime, 'HH:mm')}
                          />
                        </Col>
                      </Form.Group>


                      <Form.Group as={Row} controlId="formTime1">
                        <Form.Label column sm={4}>
                        </Form.Label>

                      </Form.Group>

                    </Card.Body>
                  </Card>
                  <Button
                    className="review-btn"
                    variant="primary"
                    onClick={() => addTimeSlot(false)}
                    disabled={!slotDt}
                  > Add Slot </Button>


                </Card.Body>
              </Card>
              <Card >
                <Card.Body>
                  <Card.Title>Recurrence Time Slot Preference</Card.Title>

                  <Card>
                    <Card.Body>
                      <div className="preference-card-title">
                      </div>
                      <Form.Group as={Row} controlId="formTime1">
                        <Form.Label column sm={4}>
                          Days
                        </Form.Label>

                        <Col sm={8}>
                          <Multiselect options={options} // Options to display in the dropdown
                            onSelect={(getSelectedItems) => setRecDays(getSelectedItems)}
                            displayValue="name"
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formDate1 required">
                        <Form.Label column sm={4}>
                          Start Date
                        </Form.Label>
                        <Col sm={8}>
                          <DatePicker
                            className="date-pick"
                            selected={recStartDate}
                            dateFormat="dd/MM/yyyy"
                            onChange={(date) => { setRecStartDate(date); setShowAlertMessage(false); }}
                            maxDate={addDays(
                              moment(new Date()).toDate(),
                              90
                            )}
                            minDate={new Date()}
                            filterDate={isValidDate}
                            placeholderText="Select a date"
                            required={true}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formDate1 required">
                        <Form.Label column sm={4}>
                          End Date
                        </Form.Label>
                        <Col sm={8}>
                          <DatePicker
                            className="date-pick"
                            selected={recEndDate}
                            dateFormat="dd/MM/yyyy"
                            onChange={(date) => { setRecEndDate(date); setShowAlertMessage(false); }}
                            maxDate={addDays(
                              moment(new Date()).toDate(),
                              90
                            )}
                            minDate={new Date()}
                            filterDate={isValidDate}
                            placeholderText="Select a date"
                            required={true}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formTime1">
                        <Form.Label column sm={4}>
                          Start Time Slot
                        </Form.Label>
                        <Col sm={8}>
                          <TimePicker

                            minuteStep={15}
                            disabledHours={() => [0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23, 24]}
                            hideDisabledOptions={true}
                            format="HH:mm"
                            onSelect={(time) => {
                              setSlotStartTime(moment(time).format('HH:mm'));
                              setShowAlertMessage(false);
                            }}
                            autoFocus={true}
                            h
                            value={moment(slotStartTime, 'HH:mm')}
                          />

                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="formTime1">
                        <Form.Label column sm={4}>
                          End Time Slot
                        </Form.Label>
                        <Col sm={8}>
                          <TimePicker

                            minuteStep={15}
                            disabledHours={() => [0, 1, 2, 3, 4, 5, 6, 7, 8, 22, 23, 24]}
                            hideDisabledOptions={true}
                            format="HH:mm"
                            onSelect={(time) => {
                              setSlotEndTime(moment(time).format('HH:mm'));
                              setShowAlertMessage(false);
                            }}
                            autoFocus={true}
                            value={moment(slotEndTime, 'HH:mm')}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="formTime1">
                        <Form.Label column sm={4}>
                        </Form.Label>

                      </Form.Group>
                    </Card.Body>
                  </Card>
                  <Button
                    className="review-btn"
                    variant="primary"
                    onClick={() => addTimeSlot(true)}
                    disabled={!recStartDate || !recEndDate}
                  > Add Recurrence Slot </Button>
                </Card.Body>
              </Card>
              <Alert
                className="form-alert"
                show={showAlertMessage}
                variant="danger"
              >
                {alertMessageContent}
              </Alert>


            </React.Fragment>

            <React.Fragment >
              <Card className="review-card">
                <Card.Title className="review-card-title">
                  Review Details
                </Card.Title>
                <Card.Body>
                  <Table responsive borderless className="table-responsive-sm">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Preference</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>

                      {data.map((row, i) => {
                        return (<tr key={i}>
                          <td><input type="checkbox" defaultChecked={row.isSlected}
                            onClick={(event) => { row.isSlected = event.target.checked }} />
                          </td>
                          <td>{row.slotDate}</td>
                          <td>{row.slotStart}</td>
                          <td>{row.slotEnd}</td>
                        </tr>);
                      })}
                    </tbody>
                  </Table>
                  <Button className="review-btn" onClick={deleteAllTimeSlot}>Delete</Button>
                </Card.Body>

                <Button className="review-btn" onClick={handleSubmit}>Submit</Button>
              </Card>
              <Card className="information-card-2">
                <Card.Title className="review-card-title">Important</Card.Title>
                <Card.Body>
                  <Card.Text className="text-left" >{footerText}</Card.Text>
                </Card.Body>
                <Form.Group controlId="formBasicCheckbox" required></Form.Group>
              </Card>
              <Alert
                className="form-alert-2"
                show={showAlertMessage2}
                variant="warning"
              >
                {alertMessageContent2}
              </Alert>

            </React.Fragment>

          </Form>
          {validatedForm && <Redirect to="/thankyou"></Redirect>}
        </div>
      </div>
    );
  };



  export default PanelResponse;